import { c as _c } from "react/compiler-runtime";
import type { BigIntish } from '@morpho-org/blue-sdk';
import { toBigInt, ZERO } from '@morpho-org/dapp-core';
import { isDefined } from '@morpho-org/morpho-ts';
import { memo, useMemo } from 'react';
import { formatPreciseDuration } from '@/components/VaultPage/helpers/timelock';
import { getDecodedFunctionNameLabel, getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
interface VaultV2PendingTimelockChangeTimelockProps {
  newValue: BigIntish;
  functionName: string;
  decodedFunctionName: string;
  timelocks: Array<{
    functionName: string;
    duration: BigIntish;
  }>;
}
const VaultV2PendingTimelockChangeTimelock = t0 => {
  const $ = _c(24);
  const {
    newValue,
    functionName,
    decodedFunctionName,
    timelocks
  } = t0;
  let t1;
  if ($[0] !== decodedFunctionName || $[1] !== timelocks) {
    t1 = timelocks.find(timelock => timelock.functionName === decodedFunctionName)?.duration;
    $[0] = decodedFunctionName;
    $[1] = timelocks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const currentValue = t1;
  let t2;
  if ($[3] !== functionName) {
    t2 = getTimelockFunctionConfig({
      functionName
    });
    $[3] = functionName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    criticality
  } = t2;
  let t3;
  if ($[5] !== decodedFunctionName) {
    t3 = getDecodedFunctionNameLabel(decodedFunctionName);
    $[5] = decodedFunctionName;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const label = t3;
  let t4;
  if ($[7] !== criticality) {
    t4 = <VaultPendingTimelockHeader title="Change timelock duration" criticality={criticality} />;
    $[7] = criticality;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="text-2xs text-foreground">Action</span>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== label) {
    t6 = <StyledVaultPendingTimelock.Row>{t5}<span className="text-2xs text-foreground">{label}</span></StyledVaultPendingTimelock.Row>;
    $[10] = label;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== currentValue) {
    t7 = isDefined(currentValue) && <StyledVaultPendingTimelock.Row><span className="text-2xs text-foreground">Current value</span><span className="text-2xs text-foreground">{currentValue === ZERO ? "No timelock" : formatPreciseDuration(currentValue)}</span></StyledVaultPendingTimelock.Row>;
    $[12] = currentValue;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-2xs text-foreground">New value</span>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== newValue) {
    t9 = newValue ? formatPreciseDuration(toBigInt(newValue)) : "No timelock";
    $[15] = newValue;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <StyledVaultPendingTimelock.Row>{t8}<span className="text-2xs text-foreground">{t9}</span></StyledVaultPendingTimelock.Row>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t4 || $[21] !== t6 || $[22] !== t7) {
    t11 = <div className="flex flex-col">{t4}{t6}{t7}{t10}</div>;
    $[19] = t10;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};
export default memo(VaultV2PendingTimelockChangeTimelock);